module.exports = __webpack_public_path__ + "img/LBA-ArticleSearch.e3e43623.svg";